module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cp_stills_pet_500_pwd_manzana.6efd159f.png";